import { HttpService } from '@/data/http/http-service';
import { getVenuePresetsDtoSchema } from '@/data/http/project-venue-presets/project-venue-presets.dto.schema.ts';
import { VenuePresetsMapper } from '@/data/http/project-venue-presets/project-venue-presets.mapper.ts';
import { VenuePreset } from '@/domain/project-venue-presets/entities/project-venue-presets.entity.ts';
import { ProjectVenuePresetsGateway } from '@/domain/project-venue-presets/gateways/project-venue-presets.gateway.ts';
import { getColorForPreset } from '@/ui/utils/get-color-for-preset.ts';

export class ApiProjectVenuePresetsHttpGateway implements ProjectVenuePresetsGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_PROJECT,
  });

  async getAll(projectId: number): Promise<VenuePreset[]> {
    const url = `/presets?projectId=${projectId}`;
    const options = { params: { $limit: 1000 } };
    const response = await this.http.get(url, options);
    const result = getVenuePresetsDtoSchema.safeParse(response.data);
    if (!result.success) {
      console.error(result.error);
      throw result.error;
    }
    const items = result.data.data.map((x) =>
      VenuePresetsMapper.dtoToEntity(x),
    );
    const itemsWithColors = items.map((item, index) => ({
      ...item,
      presetColor: getColorForPreset(index),
    }));
    return itemsWithColors;
  }

  async create(presetForm: VenuePreset): Promise<void> {
    const url = '/presets';
    const data = VenuePresetsMapper.entityToDto(presetForm);
    const response = await this.http.post(url, data);
    if (response.status === 201) {
      return;
    } else {
      throw 'error on creation';
    }
  }

  async update(presetForm: VenuePreset): Promise<void> {
    if (!presetForm.id) {
      throw 'error on update';
    }
    const url = `/presets/${presetForm.id}`;
    const data = VenuePresetsMapper.entityToDto(presetForm);
    const response = await this.http.patch(url, data);
    if (response.status === 200) {
      return;
    } else {
      throw 'error on update';
    }
  }
}
